import { useTranslation } from "react-i18next";
import { Tab } from "semantic-ui-react";

import { CustomerAppointmentsTable, CustomerCarsTable } from "components/CustomerModal/components/CustomerCarAppointmentDetails/components";
import "components/CustomerModal/components/CustomerCarAppointmentDetails/CustomerCarAppointmentDetails.scss";

import type { Appointment, Car, DealerLocation } from "models";

type CustomerCarAppointmentDetailsProps = {
  cars?: Car[];
  appointments?: Appointment[];
  location?: DealerLocation | null;
};

export const CustomerCarAppointmentDetails = ({ appointments, cars, location }: CustomerCarAppointmentDetailsProps) => {
  const { t } = useTranslation();

  return (
    <div className="CustomerCarAppointmentDetails">
      <Tab
        grid={{ paneWidth: 16, tabWidth: 8 }}
        panes={[
          {
            menuItem: t("v8_appointments", "Appointments"),
            render: () => (
              <Tab.Pane>
                <CustomerAppointmentsTable appointments={appointments} location={location} />
              </Tab.Pane>
            )
          },
          {
            menuItem: t("v8_cars", "Cars"),
            render: () => (
              <Tab.Pane>
                <CustomerCarsTable cars={cars} location={location} />
              </Tab.Pane>
            )
          }
        ]}
      />
    </div>
  );
};
